import {Role} from "@leap4/auth";

export const baseBackendRoute = process.env.REACT_APP_BACKEND_BASE_URL + "";
export const BACKEND_SERVICE_NAME = "xam-backend";
export const logoutUrl = baseBackendRoute + "/app/logout";
export const requiredAuthRoles: Role[] = [Role.ADMIN];
export const meMultiUrl = baseBackendRoute + "/app/me_multi";
export const setCookieUrl = baseBackendRoute + "/app/set-cookie";
export const loginUrl = (process.env.REACT_APP_AUTH_SERVER_BASE_URL || "https://api.auth.adte-system.com") + "/users/login";
export const OrganizationsBaseUrl = baseBackendRoute + "/organizations";
export const organizationPartnersUrl = baseBackendRoute + '/organizations/partners';
export const PublisherLoginsBaseUrl = baseBackendRoute + "/publisher_logins";
export const AdvertiserLoginsBaseUrl = baseBackendRoute + "/advertiser-logins";
export const AdvertiserLoginPartnersUrl = baseBackendRoute + "/advertiser-logins/partners";
export const ownershipsSupply = baseBackendRoute + "/ownerships/supply";
export const AddOwnershipBaseUrl = baseBackendRoute + "/ownerships/add";
export const OrganizationsSubmitChanges = baseBackendRoute + "/organizations/submit";
export const OrganizationsUpdatePartners = baseBackendRoute + "/organizations/updatePartners";
export const createNewOrganizationUrl = baseBackendRoute + "/organizations/create";
export const UsersBaseUrl = baseBackendRoute + "/users";
export const deleteOwnershipUrl = baseBackendRoute + "/ownerships/delete";
export const getClientForOrganizationUrl = baseBackendRoute + "/clients";
